
const introduct = resolve => require(['@/components/introduct/index'],resolve);
const notice = resolve => require(['@/components/introduct/notice'],resolve);
export default [
	{
		path : 'introduct',
		name : 'introduct',
		meta : {
			title : '介绍',
			searchDisabled : true
		},
		component : introduct
	},
	{
		path : 'notice',
		name : 'notice',
		meta : {
			title : '公告',
			searchDisabled : true
		},
		component : notice
	}
]



// WEBPACK FOOTER //
// ./src/router/introduct/index.js